import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { ProfileTabContent } from './ProfileTabContent';
import { AdminOrganizations } from '@platform/client';
import { ProjectTabContent } from './ProjectTabContent';
import { useState } from 'react';
import { UpdateAppStatusModal } from './UpdateApplicationStatusModal';
import { OrganizationApplicationStatusEnum } from '@platform/client/schemas';
import { EditOrganizationModal } from './EditOrganizationModal';
import { MatchingTabContent } from './MatchingTabContent';
import { TeamMatchingTabContent } from './TeamMatchingTabContent';

export const OrganizationDetail = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [editAppStatusModalOpen, setEditAppStatusModalOpen] = useState(false);
  const [editOrgModalOpen, setEditOrgModalOpen] = useState(false);
  const orgIdInt = parseInt(organizationId);
  const {
    data: orgData,
    isLoading,
    isError,
    isSuccess,
  } = AdminOrganizations.useGetReviewData(orgIdInt);

  return (
    <>
      <AdminDetailPage
        isError={isError}
        isLoading={isLoading}
        isSuccess={isSuccess}
        title={orgData?.name ?? 'MovingWorlds Organization'}
        tabs={[
          { id: 'Profile', content: <ProfileTabContent organizationData={orgData} /> },
          // { id: 'Representatives', content: <RepUsersContent /> },
          { id: 'Projects', content: <ProjectTabContent organizationId={orgIdInt} /> },
          { id: 'Matching', content: <MatchingTabContent organizationId={orgIdInt} /> },
          { id: 'Teams', content: <TeamMatchingTabContent organizationId={orgIdInt} /> },
          // { id: 'Meetings', content: <div>EIR Info</div> },
        ]}
        pageActions={[
          {
            text: 'Update Application Status',
            onPress: () => setEditAppStatusModalOpen(true),
            type: 'button',
          },
          {
            text: 'Edit Organization',
            onPress: () => setEditOrgModalOpen(true),
            type: 'button',
          },
        ]}
      />
      {editAppStatusModalOpen && orgData && (
        <UpdateAppStatusModal
          organizationId={orgData.organizationId}
          applicationId={orgData.applicationId as number}
          status={orgData.applicationStatus as OrganizationApplicationStatusEnum}
          onClose={() => setEditAppStatusModalOpen(false)}
        />
      )}
      {editOrgModalOpen && orgData && (
        <EditOrganizationModal
          onClose={() => setEditOrgModalOpen(false)}
          organizationId={orgData.organizationId}
          status={orgData.applicationStatus as OrganizationApplicationStatusEnum}
          applicationId={orgData.applicationId as number}
        />
      )}
    </>
  );
};
